export const EVENT_OPEN_CONTACT_LINKS_DIALOG = "open-contact-links-dialog";
export const EVENT_CLOSE_CONTACT_LINKS_DIALOG = "close-contact-links-dialog";
